import { Box, Skeleton } from "@mui/material";

/**
 * GenericSkeleton — single card with title bar and content bars.
 * Used for Events, Settings, and Manifest tabs.
 */
export function GenericSkeleton(): React.ReactElement {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "12px",
        p: 2.5,
        bgcolor: "background.paper",
      }}
    >
      <Skeleton variant="text" width={120} height={16} sx={{ mb: 1.75 }} />
      <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1.5 }} />
      <Skeleton variant="text" width="70%" height={20} sx={{ mb: 1.5 }} />
      <Skeleton variant="text" width="50%" height={20} />
    </Box>
  );
}

export default GenericSkeleton;
